import { ExperienceStatus } from '@dadohr/shared/domainTypes/experience';
import assertNever from 'assert-never';
import { useMemo } from 'react';
import { Color, ColoredChipDark } from '../../../../components/ColoredChip';
import { UnsafeTFunction, useUnsafeTranslation } from '../../../../i18next';

const getConfig = (
  status: ExperienceStatus,
  t: UnsafeTFunction
): [string, Color] => {
  switch (status) {
    case ExperienceStatus.SUGGESTED:
      return [t('Suggested'), 'yellow'];
    case ExperienceStatus.NOT_STARTED:
      return [t('Upcoming'), 'gray'];
    case ExperienceStatus.RUNNING:
      return [t('On Time'), 'blue'];
    case ExperienceStatus.LATE:
      return [t('Overdue'), 'red'];
    case ExperienceStatus.COMPLETE:
      return [t('Done'), 'green'];
    case ExperienceStatus.ABORTED:
      return [t('Aborted'), 'black'];
    default:
      return assertNever(status);
  }
};
export const InstanceStatusChip = ({
  status,
  size
}: {
  status: ExperienceStatus;
  size?: 'medium' | 'small';
}) => {
  const { t } = useUnsafeTranslation();

  const [label, color] = useMemo(() => getConfig(status, t), [status, t]);
  return (
    <ColoredChipDark color={color} size={size}>
      {label}
    </ColoredChipDark>
  );
};
